import { Delegate } from "dom-delegate";

let instances = [];

class AnchorNav {
    constructor(element) {
        this.ignoreIntersections = false;
        this.element = element;
        this.listener = new Delegate(element);
        this.childAnchorTags = element.querySelectorAll("a");
        this.bindAncherClickEvents();

        this.markActiveAnchor(this.childAnchorTags[0].href.split("#")[1]);

        if (window.location.hash) {
            this.markActiveAnchor(window.location.hash);
        }

        this.beginIntersectionObserver();
        this.muteIntersectionsFor(1000);
    }

    markActiveAnchor(id) {
        this.childAnchorTags.forEach((anchor) => {
            if (anchor.href.endsWith(id)) {
                anchor.classList.add(this.element.getAttribute("data-active-class"));
            } else {
                anchor.classList.remove(this.element.getAttribute("data-active-class"));
            }
        });
    }

    bindAncherClickEvents() {
        this.listener.on("click", "a", (e) => {
            e.preventDefault();
            this.muteIntersectionsFor(1000);
            this.markActiveAnchor(e.target.href.split("#")[1]);
        });
    }

    beginIntersectionObserver() {
        this.observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting && !this.ignoreIntersections) {
                        this.markActiveAnchor(entry.target.id);
                    }
                });
            },
            // This is the rootMargin for the observer. It's set to -80% so that the anchor is
            // marked as active when intersecting with the top 20% of the viewport. A value
            // of -80% reduces from the bottom of the root (viewport) bounding box by 80%.
            { rootMargin: "0% 0% -80% 0%" },
        );

        this.childAnchorTags.forEach((anchor) => {
            const target = document.querySelector("#" + anchor.href.split("#")[1]);
            this.observer.observe(target);
        });
    }

    muteIntersectionsFor(ms) {
        this.ignoreIntersections = true;
        setTimeout(() => {
            this.ignoreIntersections = false;
        }, ms);
    }

    unbindEvents() {
        this.listener.destroy();
        this.observer.disconnect();
    }
}

export default {
    init: (element) => {
        instances.push(new AnchorNav(element));
    },

    destroy: () => {
        instances.forEach((instance) => instance.destroy());
        instances = [];
    },
};
